import * as Sentry from "@sentry/react";

/**
 * Initialize Sentry error monitoring and performance tracing for Hero UI.
 * Gracefully no-ops if VITE_SENTRY_DSN is not configured.
 */
export function initSentry() {
  const dsn =
    import.meta.env.VITE_SENTRY_DSN ||
    "https://0411e5171dbf8a740610c9d84148cd66@o4512300215697408.ingest.us.sentry.io/4512300524896256";
  if (!dsn) {
    console.info("[Sentry] VITE_SENTRY_DSN not set. Sentry monitoring is disabled.");
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Tracing
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // Session Replays: 10% on normal sessions, 100% on sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}
